import { Box, Card, CardContent, Typography, Grid } from "@mui/material";

const StatusCard = ({ data }) => {
  // Helper to generate box shadow with soft colored glow
  const getBoxShadow = (color) =>
    `0 4px 10px rgba(0, 0, 0, 0.1), 0 0 10px ${color}40`; // 25% opacity

  return (
    <Grid container spacing={2}>
      {data.map((item) => (
        <Grid item xs={6} sm={3} key={item.label}>
          <Card
            sx={{
              height: '100%',
              borderRadius: '16px', // Smooth corners
              boxShadow: getBoxShadow(item.color),
              overflow: 'hidden', // Prevent clipping of rounded corners
            }}
          >
            <CardContent sx={{ padding: 0 }}>
              {/* Title bar with background */}
              <Box
                sx={{
                  backgroundColor: item.color,
                  textAlign: 'center',
                  py: 1,
                }}
              >
                <Typography
                  variant="h6"
                  fontWeight="400"
                  sx={{ fontSize: "1.15rem" }}
                  color="white"
                >
                  {item.label}
                </Typography>
              </Box>

              {/* Count Display */}
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                py={2}
              >
                <Typography
                  variant="h3"
                  fontWeight="400"
                  color={item.color}
                  sx={{ fontSize: "48px" }}
                >
                  {item.count}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default StatusCard;
